import { createContext, useContext } from 'react';
import { Map } from 'mapbox-gl';

type MapContextType = {
  map: Map | null;
};

export const MapContext = createContext<MapContextType>({
  // mapboxgl.Map instance
  map: null
});

export const useMap = (): Map | null => {
  const context = useContext(MapContext);
  if (!context) {
    throw new Error('useMap must be used within the MapContext.Provider');
  }
  return context.map;
};

export default useMap;
